module.exports = __webpack_public_path__ + "static/img/luck_img.7b2875a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/luck_img.png
// module id = A5zt
// module chunks = 0